import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight, ArrowLeft } from "lucide-react";

export default function ServizioDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/services/${slug}`).then((r) => setS(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <div className="max-w-3xl mx-auto px-4 py-32 text-center"><h1 className="font-display text-3xl">Servizio non trovato</h1><Link to="/servizi" className="text-[#007A3D] mt-6 inline-block">← Torna ai servizi</Link></div>;
  if (!s) return <div className="h-screen flex items-center justify-center text-[#6B7280]">Caricamento…</div>;

  return (
    <div data-testid={`page-servizio-${s.slug}`}>
      <section className="pt-20 md:pt-28">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/servizi" className="text-sm text-[#6B7280] hover:text-[#007A3D] inline-flex items-center gap-1.5"><ArrowLeft className="w-4 h-4" /> Servizi</Link>
          <h1 className="mt-6 font-display font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-[#1A1A1A]">{s.name}</h1>
          <p className="mt-6 text-xl text-[#6B7280] leading-relaxed max-w-3xl">{s.short}</p>
        </div>
      </section>
      <section className="py-16 md:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="aspect-[16/8] rounded-3xl overflow-hidden">
            <img src={s.image} alt={s.name} className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
      <section className="pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose-betelgez">
            <p>{s.long}</p>
          </div>
          <div className="mt-12 rounded-3xl bg-[#EAF8F0] p-8 md:p-10 text-center">
            <h3 className="font-display font-bold text-2xl text-[#1A1A1A]">Parliamo del tuo caso specifico</h3>
            <p className="mt-3 text-[#374151]">Una consulenza iniziale ci permette di valutare insieme la strada migliore.</p>
            <Link to="/contatti" data-testid="servizio-cta" className="mt-6 inline-flex items-center gap-2 bg-[#00A651] hover:bg-[#007A3D] text-white rounded-full px-7 py-4 font-medium">
              Richiedi una Consulenza <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="mt-10 text-center">
            <Link to="/consulenza-imprese-agricole-sardegna" className="text-[#007A3D] underline underline-offset-4 hover:text-[#00A651]">Leggi la guida completa alla consulenza per le imprese agricole in Sardegna</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
